import { IACDLEvent } from '../../../services/eventBus.service';

export const UserInfoLoadedEventType = Symbol('USER_INFO_LOADED_EVENT');

export class UserInfoLoadedEvent implements IACDLEvent {
  readonly type: symbol = UserInfoLoadedEventType;
}
